<template>
  <span id="cases-and-claims-detail">
    <i class="el-icon-search header-info-dialog-value icon-action"
       @click="dialogVisible = true"
       size="mini"></i>

    <el-dialog
        id="accounts-detail-dialog"
        :visible.sync="dialogVisible"
        width="80%"
        top="5vh"
        :close-on-click-modal="false"
        append-to-body
        custom-class="professional-dialog"
    >
      <div slot="title" class="dialog-header">
        <span class="title-text">{{ $t('daysOfService.informationTitle') }}</span>
        <el-tag :type="statusTagType" effect="dark" size="small" class="status-tag">
          {{ getNameStatusClaim(caseAndClaim.statusClaim) }}
        </el-tag>
      </div>

      <el-tabs v-model="activeTab" type="border-card" class="detail-tabs">

        <el-tab-pane name="first">
          <span slot="label"><i class="el-icon-info"></i> General</span>

          <div class="section-container">
            <h4 class="section-title">{{ $t('casesAndClaims.informationTitle') }} </h4>
            <el-row :gutter="20">
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.caseNumber') }} </label>
                <p>{{ caseAndClaim.caseNumber }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.callerType') }} </label>
                <p>{{ getNameCallerType(caseAndClaim.callerType) }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.callerName') }} </label>
                <p>{{ caseAndClaim.callerName }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.billTo') }} </label>
                <p>{{ caseAndClaim.billToName }} </p>
              </el-col>
            </el-row>
          </div>

          <div class="section-container">
            <h4 class="section-title">Additional Details</h4>
            <el-row :gutter="20">
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.type') }} </label>
                <p>{{ getType(caseAndClaim.type) }} </p>
              </el-col>
               <el-col v-if="isTypeInquiry" :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.inquiry') }} </label>
                <p>{{ caseAndClaim.caseReasonInquiry  }} </p>
              </el-col>
               <el-col v-if="isTypeMaintenance" :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.maintenance') }} </label>
                <p>{{ getCaseReasonMaintenance(caseAndClaim.caseReasonMaintenance)  }} </p>
              </el-col>
              <el-col v-if="isTypeMaintenanceAndOther" :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.maintenanceNotes') }} </label>
                <p>{{ caseAndClaim.maintenanceNotes }} </p>
              </el-col>
              <el-col v-if="isTypeReport" :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.report') }} </label>
                <p>{{ getCaseReasonReport(caseAndClaim.caseReasonReport ) }} </p>
              </el-col>
              <el-col v-if="isTypeReportAndOther" :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.reportNotes') }} </label>
                <p>{{ caseAndClaim.reportNotes }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.subject') }} </label>
                <p>{{ caseAndClaim.subject }} </p>
              </el-col>
            </el-row>
            <br><br>
            <el-row gutter="20">
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.caseOrigin') }} </label>
                <p>{{ getCaseOrigin(caseAndClaim.caseOrigin) }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.priority') }} </label>
                <p>{{ getPriority(caseAndClaim.priority) }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.amount') }} </label>
                <p class="highlight-text">{{ caseAndClaim.amount | currency }}</p>
              </el-col>
            </el-row>
          </div>

          <div class="section-container no-border">
  <h4 class="section-title">{{ $t('casesAndClaims.descriptionInformation') }}</h4>

  <el-row :gutter="20">
    <el-col :span="12" class="data-field">
        <label> {{ $t('casesAndClaims.description') }}</label>
        <p class="field-text">{{ caseAndClaim.description || 'No description provided' }} </p>
    </el-col>

    <el-col :span="12" class="data-field">
        <label class="field-label">{{ $t('casesAndClaims.internalComments') }}</label>
        <p class="field-text">{{ caseAndClaim.internalComments || 'No internal comments provided' }} </p>
    </el-col>
  </el-row>
</div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-suitcase"></i> Case</span>
               <div class="section-container">
            <h4 class="section-title">{{ $t('claims.caseInformation')  }} </h4>
          <el-row :gutter="20">
             <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.quantity') }} </label>
                <p>{{ caseAndClaim.quantity }} </p>
              </el-col>
            <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.faultCode') }} </label>
                <p>{{ getFaultCode(caseAndClaim.faultCode) }} </p>
              </el-col>
            <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.estimatedFreightAmount') }} </label>
                <p class="highlight-text">{{ caseAndClaim.estimatedFreightAmount | currency }} </p>
              </el-col>
            <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.estimatedClaimAmount') }} </label>
                <p class="highlight-text">{{ caseAndClaim.estimatedClaimAmount | currency }} </p>
              </el-col>
          </el-row>
          <br><br>
          <el-row :gutter="20">
            <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.overrideEstimatedClaimAmount') }} </label>
                <p>{{ getBooleanLabel(caseAndClaim.overrideEstimatedClaimAmount) }} </p>
              </el-col>
          </el-row>
               </div>
        </el-tab-pane>

        <el-tab-pane v-if="caseAndClaim.statusClaim >= 2">
          <span slot="label"><i class="el-icon-money"></i> Claim</span>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-card shadow="never" class="amount-card requested">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-warning-outline"></i> Requested Amounts </span>
                </div>
                <div class="amount-item">
                  <span>Products</span>
                  <b>{{ caseAndClaim.claim.requestedProductsAmount | currency }} </b>
                </div>
                <div class="amount-item">
                  <span>Freight</span>
                  <b>{{ caseAndClaim.claim.requestedFreightAmount | currency }} </b>
                </div>
                <div class="amount-item">
                  <span>Other</span>
                  <b>{{ caseAndClaim.claim.requestedOtherAmount | currency }} </b>
                </div>
                <div class="amount-total">
                  <span>Total Requested</span>
                  <span class="total-val">{{ caseAndClaim.claim.requestedAmount | currency }} </span>
                </div>
              </el-card>
            </el-col>

            <el-col :span="12">
              <el-card shadow="never" class="amount-card approved">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-circle-check"></i> Approved Amounts </span>
                </div>
                <div class="amount-item">
                  <span>Paid Products</span>
                  <b>{{ caseAndClaim.claim.approvedProductsAmount | currency }} </b>
                </div>
                <div class="amount-item">
                  <span>Paid Freight</span>
                  <b>{{ caseAndClaim.claim.approvedFreightAmount | currency }} </b>
                </div>
                <div class="amount-item">
                  <span>Paid Other</span>
                  <b>{{ caseAndClaim.claim.approvedOtherAmount | currency }} </b>
                </div>
                <div class="amount-total success">
                  <span>Total Approved</span>
                  <span class="total-val">{{ caseAndClaim.claim.approvedAmount | currency }} </span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane>
          <span slot="label"><i class="el-icon-truck"></i> Logistics</span>

          <div class="section-container">
            <h4 class="section-title">{{ $t('casesAndClaims.shipmentDetails') }} </h4>
            <el-row :gutter="20">
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.loadNumber') }} </label>
                <p>{{ caseAndClaim.loadNumber }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.billOfLanding') }} </label>
                <p>{{ caseAndClaim.billOfLanding }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.invoiceNumber') }} </label>
                <p>{{ caseAndClaim.invoiceNumber }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.pickupDate') }} </label>
                <p>{{ formatDate(caseAndClaim.pickupDate) }} </p>
              </el-col>
            </el-row>
            <br><br>
            <el-row :gutter="20">
                <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.shipment') }} </label>
                <p>{{ caseAndClaim.shipmentNumber }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.shipper') }} </label>
                <p>{{ caseAndClaim.shipperName }} </p>
              </el-col>
              <el-col :span="6" class="data-field">
                <label>{{ $t('casesAndClaims.consignee') }} </label>
                <p>{{ caseAndClaim.consigneeName }} </p>
              </el-col>
            </el-row>
          </div>

          <div class="section-container no-border">
            <h4 class="section-title">{{ $t('casesAndClaims.units') }} </h4>
            <el-table :data="[caseAndClaim]" size="mini" border stripe>
              <el-table-column prop="asn" :label="$t('casesAndClaims.asn')" width="100"></el-table-column>
              <el-table-column prop="delivered" :label="$t('casesAndClaims.delivered')"></el-table-column>
              <el-table-column prop="invoiced" :label="$t('casesAndClaims.invoiced')"></el-table-column>
              <el-table-column prop="cooler" :label="$t('casesAndClaims.cooler')"></el-table-column>
              <el-table-column prop="received" :label="$t('casesAndClaims.received')"></el-table-column>
              <el-table-column prop="loaded" :label="$t('casesAndClaims.loaded')"></el-table-column>
             <el-table-column :label="$t('casesAndClaims.overrideUnitStatus')" width="180">
  <template slot-scope="scope">
    <i :class="scope.row.overrideUnitStatus ? 'el-icon-success success-icon' : 'el-icon-error error-icon'"></i>
    <span style="margin-left: 10px">{{ getBooleanLabel(scope.row.overrideUnitStatus) }}</span>
  </template>
</el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane>
          <span slot="label"><i class="el-icon-time"></i> Audit</span>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="audit-item">
                <label>Created by </label>
                <p><i class="el-icon-user"></i> {{ caseAndClaim.createdByUsername }} </p>
                <small>{{ formatDate(caseAndClaim.auditCreationDate) }} </small>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="audit-item">
                <label>Last modified </label>
                <p><i class="el-icon-edit"></i> {{ caseAndClaim.lastUpdatedByUsername }} </p>
                <small>{{ defaultDateWhenEmpty(caseAndClaim.auditLastUpdate) }} </small>
              </div>
            </el-col>
          </el-row>
          <br>
          <el-row :gutter="20">
             <el-col :span="12">
              <div class="audit-item">
                <label>{{ $t('casesAndClaims.webEmail') }}</label>
                <p><i class="el-icon-message"></i> {{ caseAndClaim.webEmail }} </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'NewDetailCasesAndClaims',
  props: {
    caseAndClaim: {
      type: Object,
      require: true
    },
    internal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: 'first'
    };
  },
  watch: {
    // Vigilamos cuando se abre el modal
    dialogVisible(val) {
      if (val) {
        this.activeTab = 'first';
      }
    }
  },
  computed: {
    statusTagType() {
      // Obtenemos el valor del estado del reclamo
      const s = this.caseAndClaim.statusClaim;

      // Colores de éxito / Finalización
      if ([11, 13].includes(s)) return 'success';

      // Colores de alerta / Cierre / Negación
      if ([3, 12].includes(s)) return 'danger';

      // Colores de espera / Pendientes
      if ([7, 8, 9, 10].includes(s)) return 'warning';

      // Estados iniciales o de proceso
      if ([1, 2, 4, 6].includes(s)) return '';

      return 'info'; // Color por defecto (gris)
    },
    isTypeInquiry() {
      return this.caseAndClaim.type === constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Inquiry').value;
    },
    isTypeMaintenance() {
      return this.caseAndClaim.type === constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Maintenance').value;
    },
    isTypeMaintenanceAndOther() {
      return this.caseAndClaim.type === constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Maintenance').value
          && this.caseAndClaim.caseReasonMaintenance === constants.CASES_AND_CLAIMS.MAINTENANCE_TYPE.find(item => item.label === 'Other').value;
    },
    isTypeReport() {
      return this.caseAndClaim.type === constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Report').value;
    },
    isTypeReportAndOther() {
      return this.caseAndClaim.caseReasonReport === constants.CASES_AND_CLAIMS.REPORT_TYPE.find(item => item.label === 'Other').value
          && this.caseAndClaim.type === constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Report').value;
    },
  },
  methods: {
    getNameCallerType(calletType) {
      if (calletType) {
        return constants.CASES_AND_CLAIMS.CALLER_TYPE.find(ad => ad.value === calletType).label;
      }
      return null;
    },
    getNameStatusClaim(statusClaim) {
      if (statusClaim) {
        return constants.CASES_AND_CLAIMS.STATUS_CLAIM.find(ad => ad.value === statusClaim).label;
      }
      return null;
    },
    formatDate(value) {
      if (!value) return '-';
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-');
        return `${month}/${day}/${year}`;
      }

      const date = new Date(value);
      if (isNaN(date.getTime())) return '-';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${month}/${day}/${year} ${hour}:${minutes}`;
    },
    getType(type) {
      if (type) {
        return constants.CASES_AND_CLAIMS.CASE_TYPE.find(ad => ad.value === type).label;
      }
      return null;
    },
    getCaseReasonMaintenance(reasonMaintenance) {
      if (reasonMaintenance) {
        return constants.CASES_AND_CLAIMS.MAINTENANCE_TYPE.find(ad => ad.value === reasonMaintenance).label;
      }
      return null;
    },
    getCaseReasonReport(reasonReport) {
      if (reasonReport) {
        return constants.CASES_AND_CLAIMS.REPORT_TYPE.find(ad => ad.value === reasonReport).label;
      }
      return null;
    },
    getCaseOrigin(caseOrigin) {
      if (caseOrigin) {
        return constants.CASES_AND_CLAIMS.CASE_ORIGIN_TYPE.find(ad => ad.value === caseOrigin).label;
      }
      return null;
    },
    getPriority(priority) {
      if (priority) {
        return constants.CASES_AND_CLAIMS.PRIORITY_TYPE.find(ad => ad.value === priority).label;
      }
      return null;
    },
    getFaultCode(faultCode) {
      if (faultCode) {
        return constants.CASES_AND_CLAIMS.FAULT_CODE.find(ad => ad.value === faultCode).label;
      }
      return null;
    },
    getBooleanLabel(booleanValue) {
      return booleanValue ? 'Yes' : 'No';
    },
    defaultWhenEmpty(value) {
      return value || '-';
    },
    defaultDateWhenEmpty(value) {
      if (!value) return '-';
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-');
        return `${month}/${day}/${year}`;
      }

      const date = new Date(value);
      if (isNaN(date.getTime())) return '-';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${month}/${day}/${year} ${hour}:${minutes}`;
    }
  },
};

</script>
<style scoped>
.success-icon { color: #67C23A; }
.error-icon { color: #F56C6C; }
.description-box {
  background-color: #f8f9fb;
  padding: 12px 15px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: 100%; /* Asegura que ambas cajas tengan la misma altura si están en el mismo row */
  min-height: 80px;
}


/* Estilo para el texto del contenido */
.field-text {
  font-size: 13px;
  color: #303133;
  line-height: 1.6;
  margin: 0;
}

/* Título de la sección */
.section-title2 {
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
  margin-bottom: 15px;
}
/* Contenedor del Título */
.dialog-header {
  display: flex;
  align-items: center;
}
.title-text {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-right: 15px;
}

/* Secciones de Datos */
.section-container {
  padding: 15px 0;
  border-bottom: 1px solid #f0f2f5;
  margin-bottom: 10px;
}
.no-border { border-bottom: none; }

.section-title {
  font-size: 13px;
  color: #409EFF;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 15px;
  font-weight: 700;
}

/* Campos de Datos Individuales */
.data-field label {
  display: block;
  font-size: 11px;
  color: #909399;
  margin-bottom: 4px;
  font-weight: bold;
}
.data-field p {
  font-size: 14px;
  color: #303133;
  margin: 0;
  font-weight: 500;
}
.highlight-text {
  color: #e67e22 !important;
  font-weight: bold !important;
}

/* Cajas de Montos */
.amount-card {
  border-radius: 8px;
}
.card-header {
  font-weight: bold;
  font-size: 14px;
}
.amount-card.requested { border-top: 4px solid #f39c12; }
.amount-card.approved { border-top: 4px solid #27ae60; }

.amount-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #ebeef5;
  font-size: 13px;
}
.amount-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding-top: 10px;
  color: #e67e22;
}
.amount-total .total-val {
  font-size: 20px;
  font-weight: bold;
}
.amount-total.success { color: #27ae60; }


/* Auditoría */
.audit-item {
  background: #f4f7f9;
  padding: 12px;
  border-radius: 6px;
}
.audit-item label {
  font-size: 11px;
  color: #909399;
  display: block;
}
.audit-item p { margin: 5px 0; font-weight: bold; }

/* Ajustes de Element UI Tabs */
.detail-tabs {
  box-shadow: none;
  border: none;
}
</style>
